
import { Payload } from "@/types/profile";

export const loginWindowPayloads: Payload[] = [
  // Login Window payloads
  {
    id: "login-window",
    name: "Login Window",
    description: "Configure macOS login window settings",
    category: "Security",
    supportedPlatforms: ["macos"],
    configFields: [
      {
        id: "showNameAndPassword",
        name: "Show Name and Password Fields",
        type: "boolean",
        required: false,
        default: true,
        description: "Show separate name and password fields"
      },
      {
        id: "showPowerButtons",
        name: "Show Power Buttons",
        type: "boolean",
        required: false,
        default: true,
        description: "Show restart and shut down buttons"
      },
      {
        id: "disableConsoleAccess",
        name: "Disable Console Access",
        type: "boolean",
        required: false,
        default: false,
        description: "Disable access to console at login window"
      }
    ]
  }
];
